import ActionsForm from '@/shared/mixins/actionsForm'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import Tools from '@/components/tools/Tools'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'tablesearchmiscellaneousreimbursement',
  mixins: [ActionsForm],
  data () {
    return {
      coluna: [],
      dataFucionario: [],
      formSearch: this.initialFilter ? Object.assign({}, this.initialFilter) : {},
      totalDiversos: null
    }
  },
  props: {
    prestacao: {
      type: Boolean,
      default: false
    },
    initialFilter: {
      type: Object,
      default: null
    }
  },
  watch: {
    'prestacao' () {
      this.onLoad()
    }
  },
  mounted () {
    this.colunaVerifica()
  },
  methods: {
    // Linha com despesas nas duas etapas (coordenador que tambem e tecnico) — o backend devolve a contagem.
    linhaMista (obj) {
      return obj.qtdAgTecnico > 0 && obj.qtdAgCoordenador > 0
    },
    colunaVerifica () {
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        if (this.dataFucionario.map(e => e.statusDespesa === 2 && e.loteid !== null)) {
          this.coluna = ['', 'Nome Usuário', 'Técnico', 'Coordenador', 'Função', 'Obra', 'Lote', 'Situação', 'Primeiro Adiantamento', 'Saldo Inicial', 'Reforço', 'Fim da viagem', 'Valor do adiantamento', 'Saldo', 'Qtd. Despesa', 'Total Gasto']
        } else {
          this.coluna = ['Nome Usuário', 'Técnico', 'Coordenador', 'Função', 'Obra', 'Lote', 'Situação', 'Primeiro Adiantamento', 'Saldo Inicial', 'Reforço', 'Fim da viagem', 'Valor do adiantamento', 'Saldo', 'Qtd. Despesa', 'Total Gasto']
        }
      } else {
        this.coluna = ['Nome Usuário', 'Técnico', 'Coordenador', 'Função', 'Obra', 'Situação', 'Fim da viagem', 'Valor do adiantamento', 'Saldo', 'Qtd. Despesa', 'Total Gasto']
      }
    },
    onLoad () {
      loading.push()
      this.formSearch.CompanyID = this.CompanySelected
      this.formSearch.TipoPerfil = 0
      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) || this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)) {
        MiscellaneousExpensesRepository.GetAllFuncionarioAdmin(this.formSearch)
          .then((Response) => {
            loading.pop()
            this.$refs.tableGrids.LoadAllByData(Response)
            let lista = Response.data.data || []
            // A Controladoria VE colaborador demitido: a prestacao de contas dele precisa ser fechada,
            // e quem aprova e justamente esta tela. Aqui havia um filtro que escondia todo mundo com
            // `dataDemissao` de quem nao tem RW_REAL_ESTA_ADMIN — e ele contradizia o proprio comentario
            // ao lado, que mandava manter quem esta em processo de desligamento. Quem tem os DOIS
            // (demissao lancada E emProcessoDemissao) sumia: medido em producao em 2026-09-10, o FELIPE
            // PINHEIRO LIMA (97360) com 4 despesas em AG. APROVACAO CONTROLADORIA somando R$ 543,18,
            // invisivel pra CINTHIA ZANETTI e visivel pro admin. Eram 14 colaboradores / 79 despesas /
            // R$ 3.715,84 nessa situacao. Decisao do Rodrigo (2026-09-10): a Controladoria ve, e em
            // Viagem o Transportes tambem ve — la o gate `contEmp != null || StatusDespesa ==
            // AG_APROVACAO_TRANSPORTE` (GetAllUsuarioNovoAdmin) ja liberava demitido nesse status.
            // A tarja `.being-fired` continua marcando quem esta em processo (obj.emProcessoDemissao).
            this.dataFucionario = lista
            let total = 0
            this.dataFucionario.forEach((Element, index) => {
              this.dataFucionario[index].dataViagemInicio = this.calculaDataInicoViagem(Element)
              this.dataFucionario[index].datafimviagem = this.calculaDataFimViagem(Element)
              this.dataFucionario[index].totaldespesas = Element.dataRegistroDespesa
              this.dataFucionario[index].saldo = Element.saldo
              total = total + Element.valorTotal
            })
            this.$emit('totalDespesas', total)
          })
      } else {
        MiscellaneousExpensesRepository.GetAllFuncionario(this.formSearch)
          .then((Response) => {
            loading.pop()
            this.$refs.tableGrids.LoadAllByData(Response)
            this.dataFucionario = Response.data.data
            let total = 0
            this.dataFucionario.forEach((Element, index) => {
              this.dataFucionario[index].dataViagemInicio = this.calculaDataInicoViagem(Element)
              this.dataFucionario[index].datafimviagem = this.calculaDataFimViagem(Element)
              this.dataFucionario[index].totaldespesas = Element.dataRegistroDespesa
              this.dataFucionario[index].saldo = Element.saldo
              total = total + Element.valorTotal
            })
            this.$emit('totalDespesas', total)
          })
      }
    },

    calculaDataInicoViagem (despesasviagem) {
      let dataRegistro = despesasviagem.inicio

      let datadatasviagem = despesasviagem.inicio = new Date(despesasviagem.inicio)

      if (datadatasviagem === null || datadatasviagem === undefined) return 'N/D'
      let dataViagemInicio = datadatasviagem

      if (dataViagemInicio > dataRegistro) dataViagemInicio = Element

      return dataRegistro
    },

    calculaDataFimViagem (despesasviagem) {
      let dataRegistro = despesasviagem.fim

      let datadatasviagem = despesasviagem.fim = new Date(despesasviagem.fim)

      if (datadatasviagem === null || datadatasviagem === undefined) return 'N/D'
      let dataViagemInicio = datadatasviagem

      if (dataViagemInicio > dataRegistro) dataViagemInicio = Element

      return dataRegistro
    },
    onDownloadExcel (response) {
      const obj = response.data.data
      const contentType = obj.contentType
      const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
      var a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      a.download = obj.name
      document.body.appendChild(a)
      a.click()
      // toast.success('Arquivo gerado com sucesso!')
      // loading.close()
      this.objList.forEach(element => {
        element.checked = false
      })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onSelect (data) {
      this.$emit('edit', data)
      this.$emit('filtro', this.formSearch)
    },
    generatelote () {
      loading.push()
      MiscellaneousExpensesRepository.GenerateLote(this.CompanySelected)
        .then((Response) => {
          this.onDownloadExcel(Response)
          this.onLoad()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning('Geração indisponível')
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/tablesearchmiscellaneousreimbursement/tablesearchmiscellaneousreimbursement.js